export default __webpack_public_path__ + "static/media/gallery-2-1.252bd24a.webp";